<div [hidden]="!sending || debug" id="overlay">
    <div class="center">
        <mat-spinner></mat-spinner>
    </div>
</div>
<div  fxLayout="column" fxLayoutGap="50px">
    <div fxLayout.gt-sm="row" fxLayout.lt-sm="column">
        <div fxFlex.gt-sm="60%" fxFlex.lt-sm="100%" class="info-box hide-on-init animated" animateOnScroll
            animationName="animate__animated animate__fadeInLeft animate__faster">
            <div fxLayout.gt-sm="row" fxLayout.lt-sm="column" fxLayoutAlign="start center" fxLayoutGap="30px">
                <img id="logo" src="assets/images/logo.svg">
                <h1 class="big-splash">look@<span class="">menu</span></h1>
            </div>
            <hr class="decor">
            <h2 class="header">NOWOCZESNE ROZWIĄZANIE<br /> NA TRUDNE CZASY</h2>
            <p class="description"><strong>Działasz w branży gastronomicznej?</strong> - Zapewnij sprawną obsługę i
                ogranicz do minimum bezpośredni kontakt z klientem. </p>
            <p class="description"><strong>Jesteś klientem?</strong> - Skanujesz - zamawiasz - (płacisz) -
                odbierasz. <span class="highlight"><br />
                    Bez konieczności zakładania konta. Bez&nbsp;aplikacji!</span></p>
            <a fxLayoutAlign.xs="center" mat-flat-button color="accent" routerLink="." fragment="contact-form">Zamów
                bezpłatną prezentację</a>

        </div>
        <div class="slider delay0.5 hide-on-init animated" fxFlex.gt-sm="40%" fxFlex.lt-sm="100%" animateOnScroll
            animationName="animate__animated animate__fadeIn">
            <swiper [slidesPerView]="1" [autoplay]="{ delay: 5000 }">
                <ng-template swiperSlide><img src="assets/images/mobile1s.png"></ng-template>
                <ng-template swiperSlide><img src="assets/images/mobile2s.png"></ng-template>
                <ng-template swiperSlide><img src="assets/images/mobile3s.png"></ng-template>
                <ng-template swiperSlide><img src="assets/images/mobile4s.png"></ng-template>
            </swiper>
            <img id="slider-bgnd" src="assets/images/mobile-slider-bg.png" alt="">
        </div>
    </div>
    <div fxLayout.gt-sm="row" fxLayout.lt-sm="column" fxLayoutGap="40px">
        <mat-card class="card-shadow custom-card hide-on-init delay05" fxFlex.gt-sm="50%" fxFlex.lt-sm="100%"
            fxLayout="row" fxLayoutGap="10px" animateOnScroll animationName="animate__animated animate__zoomIn">
            <div>
                <mat-icon class="big-icon pink-color">restaurant</mat-icon>
            </div>
            <div>
                <h3>Restauracja</h3>
                <p>Oferowane rozwiązanie, poza ograniczeniem kontaktów obsługi z klientem do niezbędnego minimum
                    zapewnia wydajniejszą obsługę oraz sprawne przyjmowanie zamówień od większej liczby klientów </p>
            </div>
        </mat-card>
        <mat-card class="card-shadow custom-card hide-on-init delay05" fxFlex.gt-sm="50%" fxFlex.lt-sm="100%"
            fxLayout="row" fxLayoutGap="10px" animateOnScroll animationName="animate__animated animate__zoomIn">
            <div>
                <mat-icon class="big-icon purple-color">fastfood</mat-icon>
            </div>
            <div>
                <h3>Punkt szybkiej obsługi</h3>
                <p>Wdrożenie systemu umożliwi Twoim klientom składanie zamówień bez czekania na obsługę w kolejce
                    ograniczając
                    kontakt jedynie do odbioru zamówienia</p>

            </div>
        </mat-card>
    </div>
    <mat-card class="card-shadow card-img hide-on-init delay1" fxLayout="row" animateOnScroll
        animationName="animate__animated animate__fadeIn">
        <div class="card-img-text" fxFlex.gt-sm="50%" fx.Flex.lt-sm="100%">
            <h3>look@menu</h3>
            <p>Projekt powstaje w odpowiedzi na obecna trudną sytuację panująca w branży gastronomicznej. </p>
            <p>Umożliwia <strong>bezkontaktowe składanie zamówień</strong> zarówno w&nbsp;restauracji jak i innych
                punktach gastronomicznych, foodtruckach, itp.</p>
        </div>
        <div class="table-img" fxFlex.gt-sm="50%" fxFlex.lt-sm="0%">

        </div>
    </mat-card>
    <div class="tabs-wrapper hide-mobile" animateOnScroll animationName="animate__animated animate_fadeIn">
        <h1 class="ml1"><span class="highlight">Jak to działa?</span></h1>
        <mat-tab-group class="vertical-tabs" mat-align-tabs="start" animationDuration="0ms">
            <mat-tab #tab_id *ngFor="let tab of tabs">
                <ng-template mat-tab-label>
                    <div fxLayout="row" fxLayoutAlign="space-between end" style="width: 100%">
                        <div>
                            <h3>
                                <mat-icon>{{tab.icon}}</mat-icon> {{tab.title}}
                            </h3>
                            <div class="subtitle" *ngIf="tab_id.isActive">{{tab.subtitle}}</div>
                        </div>
                        <div *ngIf="tab_id.isActive">
                            <mat-icon color="primary">arrow_forward</mat-icon>
                        </div>
                    </div>

                </ng-template>
                <ng-template matTabContent>
                    <img src="assets/images/{{tab.image}}" loading="lazy">
                </ng-template>
            </mat-tab>
        </mat-tab-group>
        <div class="rainbow-img">
            <img src="assets/images/rainbow.png" loading="lazy">
        </div>
    </div>

    <div class="hide-desktop">
        <h1>Jak to działa?</h1>
        <mat-accordion>
            <mat-expansion-panel *ngFor="let tab of tabs">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <mat-icon>{{ tab.icon }}</mat-icon>{{ tab.title }}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <h3>{{ tab.subtitle }}</h3>
                <div>
                    <img class="tab-pic-mobile" src="assets/images/{{ tab.image }}" loading="lazy">
                </div>
            </mat-expansion-panel>
        </mat-accordion>
    </div>

    <div id="contact-form" class="hide-on-init" animateOnScroll
        animationName="animate__animated animate__fadeIn animate__faster">
        <mat-card class="card-shadow custom-card">
            <h1>Chciałbyś poznać więcej szczegółów?</h1>
            <h2><span class="highlight">Napisz do nas - skontaktujemy się z Tobą!</span></h2>
            <form *ngIf="!displayMsg" (ngSubmit)="sendMessage()" [formGroup]="contactForm2" fxLayout="column">
                <mat-form-field appearance="outline">
                    <mat-label>Imię i nazwisko</mat-label>
                    <input matInput type="text" placeholder="Imię i nazwisko" formControlName="name" required
                        maxlength="50">
                    <mat-error *ngIf="name.invalid">{{getErrorMessage('name')}}</mat-error>
                </mat-form-field>
                <div fxLayout.gt-sm="row" fxLayout.lt-sm="column" fxLayoutGap.gt-sm="20px">
                    <mat-form-field appearance="outline" fxFlex.gt-sm="50%" fxFlex.lt-sm="100%">
                        <mat-label>Nr telefonu</mat-label>
                        <input matInput type="tel" placeholder="Nr telefonu" formControlName="tel" maxlength="15">
                        <mat-error *ngIf="tel.invalid">{{getErrorMessage('tel')}}</mat-error>
                    </mat-form-field>
                    <mat-form-field appearance="outline" fxFlex.gt-sm="50%" fxFlex.lt-sm="100%">
                        <mat-label>E-mail:</mat-label>
                        <input matInput type="email" placeholder="E-mail" formControlName="email" required
                            maxlength="100">
                        <mat-error *ngIf="email.invalid">{{getErrorMessage('email')}}</mat-error>
                    </mat-form-field>
                </div>
                <mat-form-field appearance="outline">
                    <mat-label>Treść wiadomości</mat-label>
                    <textarea matInput cdkTextareaAutosize cdkAutosizeMinRows="3" placeholder="Treść wiadomości"
                        formControlName="content" maxlength="500" required></textarea>
                    <mat-error *ngIf="content.invalid">{{getErrorMessage('content')}}</mat-error>
                    <mat-hint align="end">{{content.value.length}} / 500</mat-hint>
                </mat-form-field>
                <div>
                    <mat-checkbox formControlName="policy">
                        Akceptuję
                        <a routerLink="" (click)="openPPDialog();">politykę prywatności</a>
                    </mat-checkbox>
                </div>
                <div style="margin-bottom: 20px">
                    <app-recaptcha (token)="getToken($event)"></app-recaptcha>
                </div>
                <mat-error *ngIf="displayPPerror">Wysłanie formularza wymaga zaakceptowania Polityki Prywatności
                </mat-error>
                <div>
                    <button mat-flat-button color="primary" type="submit" disabled={{submitDisabled()}}>
                        Wyślij
                    </button>
                    <div *ngIf="displayErrMsg">Wystąpił problem z wysłaniem wiadomości. Prosimy spróbować później.</div>
                </div>
            </form>
            <div *ngIf="displayMsg">Dziękujemy za przesłanie wiadomości. Skontaktujemy się z Państwem tak szybko, jak to
                będzie możliwe.</div>
        </mat-card>
    </div>
</div>